export default __webpack_public_path__ + "static/media/confirm-protect-logo.ba397402.svg";